
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAppUserDeviceColorCalibration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appUserDeviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"backgroundColorHexValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetColorHexValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calibratedTargetColorHexValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAppUserDeviceColorCalibration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_appUserDeviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appUserDeviceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_backgroundColorHexValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"backgroundColorHexValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_targetColorHexValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetColorHexValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_calibratedTargetColorHexValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calibratedTargetColorHexValue"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appUserDeviceColorCalibration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appUserDeviceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundPaletteColorId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetPaletteColorId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calibratedTargetColorHexValue"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":621}};
    doc.loc.source = {"body":"mutation UpsertAppUserDeviceColorCalibration(\n  $appUserDeviceId: String!\n  $backgroundColorHexValue: String!\n  $targetColorHexValue: String!\n  $calibratedTargetColorHexValue: String!\n) {\n  upsertAppUserDeviceColorCalibration(input: {\n    _appUserDeviceId: $appUserDeviceId\n    _backgroundColorHexValue: $backgroundColorHexValue\n    _targetColorHexValue: $targetColorHexValue\n    _calibratedTargetColorHexValue: $calibratedTargetColorHexValue\n  }) {\n    appUserDeviceColorCalibration {\n      id\n    \tappUserDeviceId\n      backgroundPaletteColorId\n      targetPaletteColorId\n      calibratedTargetColorHexValue\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["UpsertAppUserDeviceColorCalibration"] = oneQuery(doc, "UpsertAppUserDeviceColorCalibration");
        
